import Pusher, { type Channel } from 'pusher-js';

import { getPusherChannelName } from '@kaiizen/kai-pro-api';
import { type RealtimeClient } from '@kaiizen/kai-pro-api-react-state';

const createChannelBindings = () => new Set<() => void>();

export const createWebRealtimeClient = (
  pusherKey: string,
  cluster: string,
): RealtimeClient => {
  console.log('[pusher-web] create client', {
    pusherKey,
    cluster,
  });
  const client = new Pusher(pusherKey, { cluster });
  const channelsByName = new Map<string, Channel>();
  const bindingsByChannelName = new Map<string, Set<() => void>>();

  const getOrCreateChannel = (logicalChannelName: string) => {
    const pusherChannelName = getPusherChannelName(logicalChannelName);
    let channel = channelsByName.get(logicalChannelName);
    if (channel) return channel;
    console.log('[pusher-web] subscribe channel', { logicalChannelName, pusherChannelName });
    channel = client.subscribe(pusherChannelName);
    channelsByName.set(logicalChannelName, channel);
    bindingsByChannelName.set(logicalChannelName, createChannelBindings());
    return channel;
  };

  return {
    subscribe: (logicalChannelName, eventName, callback) => {
      const pusherChannelName = getPusherChannelName(logicalChannelName);
      console.log('[pusher-web] bind event', {
        logicalChannelName,
        pusherChannelName,
        eventName,
      });
      const channel = getOrCreateChannel(logicalChannelName);
      const channelBindings = bindingsByChannelName.get(logicalChannelName) ?? createChannelBindings();
      bindingsByChannelName.set(logicalChannelName, channelBindings);

      channel.bind(eventName, callback);
      const unbind = () => channel.unbind(eventName, callback);
      channelBindings.add(unbind);

      return {
        unsubscribe: () => {
          unbind();
          channelBindings.delete(unbind);

          if (channelBindings.size === 0) {
            console.log('[pusher-web] unsubscribe channel', {
              logicalChannelName,
              pusherChannelName,
            });
            client.unsubscribe(pusherChannelName);
            channelsByName.delete(logicalChannelName);
            bindingsByChannelName.delete(logicalChannelName);
          }
        },
      };
    },
  };
};
